import { useTranslation } from 'react-i18next'
import { Navigate, useLocation } from 'react-router'

import { FALLBACK_LANGUAGE } from '@app/i18n'

import { getLocaleFromPath, localizeUrl, type SupportedLocale } from './utils'


/**
 * Redirects URLs without locale prefix to the localized version
 * Used at the root level to handle `/` -> `/ru/` etc.
 */
export function LocaleRedirect () {
  const { i18n } = useTranslation()
  const location = useLocation()

  const pathLocale = getLocaleFromPath(location.pathname)

  // If URL already has a valid locale, don't redirect
  if (pathLocale) {
    return null
  }

  // Determine the target locale
  const targetLocale = (i18n.language || FALLBACK_LANGUAGE) as SupportedLocale

  // Build the localized URL
  const localizedPath = localizeUrl(
    location.pathname + location.search + location.hash,
    targetLocale,
  )

  return <Navigate to={localizedPath} replace />
}
